import {render_opening_hours} from './pharmacy-search-component';

export function pharmacist_tip() {
  if ($('.section-pharmacist-tip').length > 0) {
    render_opening_hours($('.section-pharmacist-tip').find('.pharmacy-search-result'));
  }
}



// WEBPACK FOOTER //
// ./scripts/components/pharmacist_tip.js